import React, { useEffect, useState } from 'react';
import './App.css';

function PrivacyPolicy() {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch('/privacy-policy.html')
      .then(response => response.text())
      .then(data => setHtmlContent(data))
      .catch(error => console.error('Error loading privacy policy:', error));
  }, []);

  return (
    <div className="App">
      <div className="privacy-policy-container" dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
}

export default PrivacyPolicy;